var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0008 113.077C30.6666 113.077 6.92383 89.305 6.92383 60.0008C6.92383 30.6657 30.6625 6.92383 60.0008 6.92383C89.3358 6.92383 113.077 30.6625 113.077 60.0008C113.077 89.3333 89.3026 113.077 60.0008 113.077Z",
    fill: "#66A9DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 6.92383V113.077C89.3018 113.077 113.076 89.3333 113.076 60.0008C113.076 30.6633 89.335 6.92383 60 6.92383Z",
    fill: "#4F84CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0013 72.4414C44.5575 72.4414 29.8321 79.1927 19.0703 93.7901C40.5008 119.694 80.1684 119.473 101.31 93.3277C96.0892 88.1347 84.3304 72.4414 60.0013 72.4414Z",
    fill: "#D6F3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.308 93.3276C91.3273 105.67 76.3517 113.078 60 113.078V72.4414C84.3299 72.4414 96.0879 88.1363 101.308 93.3276Z",
    fill: "#BDECFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0017 63.11C49.712 63.11 41.3418 54.739 41.3418 44.4501V38.2302C41.3418 27.9413 49.712 19.5703 60.0017 19.5703C70.2905 19.5703 78.6615 27.9413 78.6615 38.2302V44.4501C78.6615 54.739 70.2905 63.11 60.0017 63.11Z",
    fill: "#D6F3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 19.5703V63.11C70.2896 63.11 78.6599 54.7398 78.6599 44.4501V38.2302C78.6599 27.9405 70.2896 19.5703 60 19.5703Z",
    fill: "#BDECFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.154,
    height: 106.154,
    fill: "white",
    transform: "translate(6.92383 6.92383)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user-avatar.8e50b1ebe4690895997273517cecd528.svg";
export { ForwardRef as ReactComponent };